"use strict";
// Copyright 2019 ProximaX Limited. All rights reserved.
// Use of this source code is governed by the Apache 2.0
// license that can be found in the LICENSE file
Object.defineProperty(exports, "__esModule", { value: true });
// automatically generated by the FlatBuffers compiler, do not modify
/**
 * @const
 * @namespace
 */
var Catapult = Catapult || {};
/**
 * @const
 * @namespace
 */
Catapult.Buffers = Catapult.Buffers || {};
/**
 * @constructor
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer = function () {
    /**
     * @type {flatbuffers.ByteBuffer}
     */
    this.bb = null;
    /**
     * @type {number}
     */
    this.bb_pos = 0;
};
/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {Catapult.Buffers.AddExchangeOfferTransactionBuffer}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.__init = function (i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
};
/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {Catapult.Buffers.AddExchangeOfferTransactionBuffer=} obj
 * @returns {Catapult.Buffers.AddExchangeOfferTransactionBuffer}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.getRootAsAddExchangeOfferTransactionBuffer = function (bb, obj) {
    return (obj || new Catapult.Buffers.AddExchangeOfferTransactionBuffer).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};
/**
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.size = function () {
    var offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.signature = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.signatureLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint8Array}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.signatureArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.signer = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.signerLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint8Array}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.signerArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.version = function () {
    var offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.type = function () {
    var offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.maxFee = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 14);
    return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.maxFeeLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 14);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.maxFeeArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 14);
    return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.deadline = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 16);
    return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.deadlineLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 16);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.deadlineArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 16);
    return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.offersCount = function () {
    var offset = this.bb.__offset(this.bb_pos, 18);
    return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
};
/**
 * @param {number} index
 * @param {Catapult.Buffers.AddExchangeOfferBuffer=} obj
 * @returns {Catapult.Buffers.AddExchangeOfferBuffer}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.offers = function (index, obj) {
    var offset = this.bb.__offset(this.bb_pos, 20);
    return offset ? (obj || new Catapult.Buffers.AddExchangeOfferBuffer).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
};
/**
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.prototype.offersLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 20);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @param {flatbuffers.Builder} builder
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.startAddExchangeOfferTransactionBuffer = function (builder) {
    builder.startObject(9);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} size
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.addSize = function (builder, size) {
    builder.addFieldInt32(0, size, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} signatureOffset
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.addSignature = function (builder, signatureOffset) {
    builder.addFieldOffset(1, signatureOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.createSignatureVector = function (builder, data) {
    builder.startVector(1, data.length, 1);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt8(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.startSignatureVector = function (builder, numElems) {
    builder.startVector(1, numElems, 1);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} signerOffset
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.addSigner = function (builder, signerOffset) {
    builder.addFieldOffset(2, signerOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.createSignerVector = function (builder, data) {
    builder.startVector(1, data.length, 1);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt8(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.startSignerVector = function (builder, numElems) {
    builder.startVector(1, numElems, 1);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} version
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.addVersion = function (builder, version) {
    builder.addFieldInt32(3, version, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} type
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.addType = function (builder, type) {
    builder.addFieldInt16(4, type, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} maxFeeOffset
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.addMaxFee = function (builder, maxFeeOffset) {
    builder.addFieldOffset(5, maxFeeOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.createMaxFeeVector = function (builder, data) {
    builder.startVector(4, data.length, 4);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt32(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.startMaxFeeVector = function (builder, numElems) {
    builder.startVector(4, numElems, 4);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} deadlineOffset
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.addDeadline = function (builder, deadlineOffset) {
    builder.addFieldOffset(6, deadlineOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.createDeadlineVector = function (builder, data) {
    builder.startVector(4, data.length, 4);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt32(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.startDeadlineVector = function (builder, numElems) {
    builder.startVector(4, numElems, 4);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} offersCount
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.addOffersCount = function (builder, offersCount) {
    builder.addFieldInt8(7, offersCount, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} offersOffset
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.addOffers = function (builder, offersOffset) {
    builder.addFieldOffset(8, offersOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<flatbuffers.Offset>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.createOffersVector = function (builder, data) {
    builder.startVector(4, data.length, 4);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addOffset(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.startOffersVector = function (builder, numElems) {
    builder.startVector(4, numElems, 4);
};
/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.endAddExchangeOfferTransactionBuffer = function (builder) {
    var offset = builder.endObject();
    return offset;
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} size
 * @param {flatbuffers.Offset} signatureOffset
 * @param {flatbuffers.Offset} signerOffset
 * @param {number} version
 * @param {number} type
 * @param {flatbuffers.Offset} maxFeeOffset
 * @param {flatbuffers.Offset} deadlineOffset
 * @param {number} offersCount
 * @param {flatbuffers.Offset} offersOffset
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.AddExchangeOfferTransactionBuffer.createAddExchangeOfferTransactionBuffer = function (builder, size, signatureOffset, signerOffset, version, type, maxFeeOffset, deadlineOffset, offersCount, offersOffset) {
    Catapult.Buffers.AddExchangeOfferTransactionBuffer.startAddExchangeOfferTransactionBuffer(builder);
    Catapult.Buffers.AddExchangeOfferTransactionBuffer.addSize(builder, size);
    Catapult.Buffers.AddExchangeOfferTransactionBuffer.addSignature(builder, signatureOffset);
    Catapult.Buffers.AddExchangeOfferTransactionBuffer.addSigner(builder, signerOffset);
    Catapult.Buffers.AddExchangeOfferTransactionBuffer.addVersion(builder, version);
    Catapult.Buffers.AddExchangeOfferTransactionBuffer.addType(builder, type);
    Catapult.Buffers.AddExchangeOfferTransactionBuffer.addMaxFee(builder, maxFeeOffset);
    Catapult.Buffers.AddExchangeOfferTransactionBuffer.addDeadline(builder, deadlineOffset);
    Catapult.Buffers.AddExchangeOfferTransactionBuffer.addOffersCount(builder, offersCount);
    Catapult.Buffers.AddExchangeOfferTransactionBuffer.addOffers(builder, offersOffset);
    return Catapult.Buffers.AddExchangeOfferTransactionBuffer.endAddExchangeOfferTransactionBuffer(builder);
};
/**
 * @constructor
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer = function () {
    /**
     * @type {flatbuffers.ByteBuffer}
     */
    this.bb = null;
    /**
     * @type {number}
     */
    this.bb_pos = 0;
};
/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {Catapult.Buffers.ExchangeOfferTransactionBuffer}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.__init = function (i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
};
/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {Catapult.Buffers.ExchangeOfferTransactionBuffer=} obj
 * @returns {Catapult.Buffers.ExchangeOfferTransactionBuffer}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.getRootAsExchangeOfferTransactionBuffer = function (bb, obj) {
    return (obj || new Catapult.Buffers.ExchangeOfferTransactionBuffer).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};
/**
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.size = function () {
    var offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.signature = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.signatureLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint8Array}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.signatureArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.signer = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.signerLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint8Array}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.signerArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.version = function () {
    var offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.type = function () {
    var offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.maxFee = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 14);
    return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.maxFeeLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 14);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.maxFeeArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 14);
    return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.deadline = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 16);
    return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.deadlineLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 16);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.deadlineArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 16);
    return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.offersCount = function () {
    var offset = this.bb.__offset(this.bb_pos, 18);
    return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
};
/**
 * @param {number} index
 * @param {Catapult.Buffers.ExchangeOfferBuffer=} obj
 * @returns {Catapult.Buffers.ExchangeOfferBuffer}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.offers = function (index, obj) {
    var offset = this.bb.__offset(this.bb_pos, 20);
    return offset ? (obj || new Catapult.Buffers.ExchangeOfferBuffer).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
};
/**
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.prototype.offersLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 20);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @param {flatbuffers.Builder} builder
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.startExchangeOfferTransactionBuffer = function (builder) {
    builder.startObject(9);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} size
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.addSize = function (builder, size) {
    builder.addFieldInt32(0, size, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} signatureOffset
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.addSignature = function (builder, signatureOffset) {
    builder.addFieldOffset(1, signatureOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.createSignatureVector = function (builder, data) {
    builder.startVector(1, data.length, 1);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt8(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.startSignatureVector = function (builder, numElems) {
    builder.startVector(1, numElems, 1);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} signerOffset
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.addSigner = function (builder, signerOffset) {
    builder.addFieldOffset(2, signerOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.createSignerVector = function (builder, data) {
    builder.startVector(1, data.length, 1);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt8(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.startSignerVector = function (builder, numElems) {
    builder.startVector(1, numElems, 1);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} version
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.addVersion = function (builder, version) {
    builder.addFieldInt32(3, version, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} type
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.addType = function (builder, type) {
    builder.addFieldInt16(4, type, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} maxFeeOffset
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.addMaxFee = function (builder, maxFeeOffset) {
    builder.addFieldOffset(5, maxFeeOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.createMaxFeeVector = function (builder, data) {
    builder.startVector(4, data.length, 4);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt32(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.startMaxFeeVector = function (builder, numElems) {
    builder.startVector(4, numElems, 4);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} deadlineOffset
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.addDeadline = function (builder, deadlineOffset) {
    builder.addFieldOffset(6, deadlineOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.createDeadlineVector = function (builder, data) {
    builder.startVector(4, data.length, 4);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt32(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.startDeadlineVector = function (builder, numElems) {
    builder.startVector(4, numElems, 4);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} offersCount
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.addOffersCount = function (builder, offersCount) {
    builder.addFieldInt8(7, offersCount, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} offersOffset
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.addOffers = function (builder, offersOffset) {
    builder.addFieldOffset(8, offersOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<flatbuffers.Offset>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.createOffersVector = function (builder, data) {
    builder.startVector(4, data.length, 4);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addOffset(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.startOffersVector = function (builder, numElems) {
    builder.startVector(4, numElems, 4);
};
/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.endExchangeOfferTransactionBuffer = function (builder) {
    var offset = builder.endObject();
    return offset;
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} size
 * @param {flatbuffers.Offset} signatureOffset
 * @param {flatbuffers.Offset} signerOffset
 * @param {number} version
 * @param {number} type
 * @param {flatbuffers.Offset} maxFeeOffset
 * @param {flatbuffers.Offset} deadlineOffset
 * @param {number} offersCount
 * @param {flatbuffers.Offset} offersOffset
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.ExchangeOfferTransactionBuffer.createExchangeOfferTransactionBuffer = function (builder, size, signatureOffset, signerOffset, version, type, maxFeeOffset, deadlineOffset, offersCount, offersOffset) {
    Catapult.Buffers.ExchangeOfferTransactionBuffer.startExchangeOfferTransactionBuffer(builder);
    Catapult.Buffers.ExchangeOfferTransactionBuffer.addSize(builder, size);
    Catapult.Buffers.ExchangeOfferTransactionBuffer.addSignature(builder, signatureOffset);
    Catapult.Buffers.ExchangeOfferTransactionBuffer.addSigner(builder, signerOffset);
    Catapult.Buffers.ExchangeOfferTransactionBuffer.addVersion(builder, version);
    Catapult.Buffers.ExchangeOfferTransactionBuffer.addType(builder, type);
    Catapult.Buffers.ExchangeOfferTransactionBuffer.addMaxFee(builder, maxFeeOffset);
    Catapult.Buffers.ExchangeOfferTransactionBuffer.addDeadline(builder, deadlineOffset);
    Catapult.Buffers.ExchangeOfferTransactionBuffer.addOffersCount(builder, offersCount);
    Catapult.Buffers.ExchangeOfferTransactionBuffer.addOffers(builder, offersOffset);
    return Catapult.Buffers.ExchangeOfferTransactionBuffer.endExchangeOfferTransactionBuffer(builder);
};
/**
 * @constructor
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer = function () {
    /**
     * @type {flatbuffers.ByteBuffer}
     */
    this.bb = null;
    /**
     * @type {number}
     */
    this.bb_pos = 0;
};
/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {Catapult.Buffers.RemoveExchangeOfferTransactionBuffer}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.__init = function (i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
};
/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {Catapult.Buffers.RemoveExchangeOfferTransactionBuffer=} obj
 * @returns {Catapult.Buffers.RemoveExchangeOfferTransactionBuffer}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.getRootAsRemoveExchangeOfferTransactionBuffer = function (bb, obj) {
    return (obj || new Catapult.Buffers.RemoveExchangeOfferTransactionBuffer).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};
/**
 * @returns {number}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.size = function () {
    var offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.signature = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.signatureLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint8Array}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.signatureArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.signer = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.signerLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint8Array}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.signerArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @returns {number}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.version = function () {
    var offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.type = function () {
    var offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.maxFee = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 14);
    return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.maxFeeLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 14);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.maxFeeArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 14);
    return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.deadline = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 16);
    return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.deadlineLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 16);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.deadlineArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 16);
    return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @returns {number}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.offersCount = function () {
    var offset = this.bb.__offset(this.bb_pos, 18);
    return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
};
/**
 * @param {number} index
 * @param {Catapult.Buffers.RemoveExchangeOfferBuffer=} obj
 * @returns {Catapult.Buffers.RemoveExchangeOfferBuffer}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.offers = function (index, obj) {
    var offset = this.bb.__offset(this.bb_pos, 20);
    return offset ? (obj || new Catapult.Buffers.RemoveExchangeOfferBuffer).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
};
/**
 * @returns {number}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.prototype.offersLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 20);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @param {flatbuffers.Builder} builder
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.startRemoveExchangeOfferTransactionBuffer = function (builder) {
    builder.startObject(9);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} size
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addSize = function (builder, size) {
    builder.addFieldInt32(0, size, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} signatureOffset
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addSignature = function (builder, signatureOffset) {
    builder.addFieldOffset(1, signatureOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.createSignatureVector = function (builder, data) {
    builder.startVector(1, data.length, 1);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt8(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.startSignatureVector = function (builder, numElems) {
    builder.startVector(1, numElems, 1);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} signerOffset
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addSigner = function (builder, signerOffset) {
    builder.addFieldOffset(2, signerOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.createSignerVector = function (builder, data) {
    builder.startVector(1, data.length, 1);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt8(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.startSignerVector = function (builder, numElems) {
    builder.startVector(1, numElems, 1);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} version
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addVersion = function (builder, version) {
    builder.addFieldInt32(3, version, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} type
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addType = function (builder, type) {
    builder.addFieldInt16(4, type, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} maxFeeOffset
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addMaxFee = function (builder, maxFeeOffset) {
    builder.addFieldOffset(5, maxFeeOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.createMaxFeeVector = function (builder, data) {
    builder.startVector(4, data.length, 4);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt32(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.startMaxFeeVector = function (builder, numElems) {
    builder.startVector(4, numElems, 4);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} deadlineOffset
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addDeadline = function (builder, deadlineOffset) {
    builder.addFieldOffset(6, deadlineOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.createDeadlineVector = function (builder, data) {
    builder.startVector(4, data.length, 4);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt32(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.startDeadlineVector = function (builder, numElems) {
    builder.startVector(4, numElems, 4);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} offersCount
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addOffersCount = function (builder, offersCount) {
    builder.addFieldInt8(7, offersCount, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} offersOffset
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addOffers = function (builder, offersOffset) {
    builder.addFieldOffset(8, offersOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<flatbuffers.Offset>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.createOffersVector = function (builder, data) {
    builder.startVector(4, data.length, 4);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addOffset(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.startOffersVector = function (builder, numElems) {
    builder.startVector(4, numElems, 4);
};
/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.endRemoveExchangeOfferTransactionBuffer = function (builder) {
    var offset = builder.endObject();
    return offset;
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} offset
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.finishRemoveExchangeOfferTransactionBufferBuffer = function (builder, offset) {
    builder.finish(offset);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} size
 * @param {flatbuffers.Offset} signatureOffset
 * @param {flatbuffers.Offset} signerOffset
 * @param {number} version
 * @param {number} type
 * @param {flatbuffers.Offset} maxFeeOffset
 * @param {flatbuffers.Offset} deadlineOffset
 * @param {number} offersCount
 * @param {flatbuffers.Offset} offersOffset
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.createRemoveExchangeOfferTransactionBuffer = function (builder, size, signatureOffset, signerOffset, version, type, maxFeeOffset, deadlineOffset, offersCount, offersOffset) {
    Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.startRemoveExchangeOfferTransactionBuffer(builder);
    Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addSize(builder, size);
    Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addSignature(builder, signatureOffset);
    Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addSigner(builder, signerOffset);
    Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addVersion(builder, version);
    Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addType(builder, type);
    Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addMaxFee(builder, maxFeeOffset);
    Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addDeadline(builder, deadlineOffset);
    Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addOffersCount(builder, offersCount);
    Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.addOffers(builder, offersOffset);
    return Catapult.Buffers.RemoveExchangeOfferTransactionBuffer.endRemoveExchangeOfferTransactionBuffer(builder);
};
/**
 * @constructor
 */
Catapult.Buffers.AddExchangeOfferBuffer = function () {
    /**
     * @type {flatbuffers.ByteBuffer}
     */
    this.bb = null;
    /**
     * @type {number}
     */
    this.bb_pos = 0;
};
/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {Catapult.Buffers.AddExchangeOfferBuffer}
 */
Catapult.Buffers.AddExchangeOfferBuffer.prototype.__init = function (i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
};
/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {Catapult.Buffers.AddExchangeOfferBuffer=} obj
 * @returns {Catapult.Buffers.AddExchangeOfferBuffer}
 */
Catapult.Buffers.AddExchangeOfferBuffer.getRootAsAddExchangeOfferBuffer = function (bb, obj) {
    return (obj || new Catapult.Buffers.AddExchangeOfferBuffer).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferBuffer.prototype.mosaicId = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferBuffer.prototype.mosaicIdLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.AddExchangeOfferBuffer.prototype.mosaicIdArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferBuffer.prototype.mosaicAmount = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferBuffer.prototype.mosaicAmountLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.AddExchangeOfferBuffer.prototype.mosaicAmountArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferBuffer.prototype.cost = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferBuffer.prototype.costLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.AddExchangeOfferBuffer.prototype.costArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferBuffer.prototype.type = function () {
    var offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferBuffer.prototype.duration = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.AddExchangeOfferBuffer.prototype.durationLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.AddExchangeOfferBuffer.prototype.durationArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @param {flatbuffers.Builder} builder
 */
Catapult.Buffers.AddExchangeOfferBuffer.startAddExchangeOfferBuffer = function (builder) {
    builder.startObject(5);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} mosaicIdOffset
 */
Catapult.Buffers.AddExchangeOfferBuffer.addMosaicId = function (builder, mosaicIdOffset) {
    builder.addFieldOffset(0, mosaicIdOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.AddExchangeOfferBuffer.createMosaicIdVector = function (builder, data) {
    builder.startVector(4, data.length, 4);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt32(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.AddExchangeOfferBuffer.startMosaicIdVector = function (builder, numElems) {
    builder.startVector(4, numElems, 4);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} mosaicAmountOffset
 */
Catapult.Buffers.AddExchangeOfferBuffer.addMosaicAmount = function (builder, mosaicAmountOffset) {
    builder.addFieldOffset(1, mosaicAmountOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.AddExchangeOfferBuffer.createMosaicAmountVector = function (builder, data) {
    builder.startVector(4, data.length, 4);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt32(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.AddExchangeOfferBuffer.startMosaicAmountVector = function (builder, numElems) {
    builder.startVector(4, numElems, 4);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} costOffset
 */
Catapult.Buffers.AddExchangeOfferBuffer.addCost = function (builder, costOffset) {
    builder.addFieldOffset(2, costOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.AddExchangeOfferBuffer.createCostVector = function (builder, data) {
    builder.startVector(4, data.length, 4);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt32(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.AddExchangeOfferBuffer.startCostVector = function (builder, numElems) {
    builder.startVector(4, numElems, 4);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} type
 */
Catapult.Buffers.AddExchangeOfferBuffer.addType = function (builder, type) {
    builder.addFieldInt8(3, type, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} durationOffset
 */
Catapult.Buffers.AddExchangeOfferBuffer.addDuration = function (builder, durationOffset) {
    builder.addFieldOffset(4, durationOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.AddExchangeOfferBuffer.createDurationVector = function (builder, data) {
    builder.startVector(4, data.length, 4);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt32(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.AddExchangeOfferBuffer.startDurationVector = function (builder, numElems) {
    builder.startVector(4, numElems, 4);
};
/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.AddExchangeOfferBuffer.endAddExchangeOfferBuffer = function (builder) {
    var offset = builder.endObject();
    return offset;
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} mosaicIdOffset
 * @param {flatbuffers.Offset} mosaicAmountOffset
 * @param {flatbuffers.Offset} costOffset
 * @param {number} type
 * @param {flatbuffers.Offset} durationOffset
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.AddExchangeOfferBuffer.createAddExchangeOfferBuffer = function (builder, mosaicIdOffset, mosaicAmountOffset, costOffset, type, durationOffset) {
    Catapult.Buffers.AddExchangeOfferBuffer.startAddExchangeOfferBuffer(builder);
    Catapult.Buffers.AddExchangeOfferBuffer.addMosaicId(builder, mosaicIdOffset);
    Catapult.Buffers.AddExchangeOfferBuffer.addMosaicAmount(builder, mosaicAmountOffset);
    Catapult.Buffers.AddExchangeOfferBuffer.addCost(builder, costOffset);
    Catapult.Buffers.AddExchangeOfferBuffer.addType(builder, type);
    Catapult.Buffers.AddExchangeOfferBuffer.addDuration(builder, durationOffset);
    return Catapult.Buffers.AddExchangeOfferBuffer.endAddExchangeOfferBuffer(builder);
};
/**
 * @constructor
 */
Catapult.Buffers.ExchangeOfferBuffer = function () {
    /**
     * @type {flatbuffers.ByteBuffer}
     */
    this.bb = null;
    /**
     * @type {number}
     */
    this.bb_pos = 0;
};
/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {Catapult.Buffers.ExchangeOfferBuffer}
 */
Catapult.Buffers.ExchangeOfferBuffer.prototype.__init = function (i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
};
/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {Catapult.Buffers.ExchangeOfferBuffer=} obj
 * @returns {Catapult.Buffers.ExchangeOfferBuffer}
 */
Catapult.Buffers.ExchangeOfferBuffer.getRootAsExchangeOfferBuffer = function (bb, obj) {
    return (obj || new Catapult.Buffers.ExchangeOfferBuffer).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferBuffer.prototype.mosaicId = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferBuffer.prototype.mosaicIdLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.ExchangeOfferBuffer.prototype.mosaicIdArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferBuffer.prototype.mosaicAmount = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferBuffer.prototype.mosaicAmountLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.ExchangeOfferBuffer.prototype.mosaicAmountArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferBuffer.prototype.cost = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferBuffer.prototype.costLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.ExchangeOfferBuffer.prototype.costArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 8);
    return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferBuffer.prototype.type = function () {
    var offset = this.bb.__offset(this.bb_pos, 10);
    return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferBuffer.prototype.owner = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.ExchangeOfferBuffer.prototype.ownerLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint8Array}
 */
Catapult.Buffers.ExchangeOfferBuffer.prototype.ownerArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 12);
    return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @param {flatbuffers.Builder} builder
 */
Catapult.Buffers.ExchangeOfferBuffer.startExchangeOfferBuffer = function (builder) {
    builder.startObject(5);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} mosaicIdOffset
 */
Catapult.Buffers.ExchangeOfferBuffer.addMosaicId = function (builder, mosaicIdOffset) {
    builder.addFieldOffset(0, mosaicIdOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.ExchangeOfferBuffer.createMosaicIdVector = function (builder, data) {
    builder.startVector(4, data.length, 4);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt32(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.ExchangeOfferBuffer.startMosaicIdVector = function (builder, numElems) {
    builder.startVector(4, numElems, 4);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} mosaicAmountOffset
 */
Catapult.Buffers.ExchangeOfferBuffer.addMosaicAmount = function (builder, mosaicAmountOffset) {
    builder.addFieldOffset(1, mosaicAmountOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.ExchangeOfferBuffer.createMosaicAmountVector = function (builder, data) {
    builder.startVector(4, data.length, 4);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt32(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.ExchangeOfferBuffer.startMosaicAmountVector = function (builder, numElems) {
    builder.startVector(4, numElems, 4);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} costOffset
 */
Catapult.Buffers.ExchangeOfferBuffer.addCost = function (builder, costOffset) {
    builder.addFieldOffset(2, costOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.ExchangeOfferBuffer.createCostVector = function (builder, data) {
    builder.startVector(4, data.length, 4);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt32(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.ExchangeOfferBuffer.startCostVector = function (builder, numElems) {
    builder.startVector(4, numElems, 4);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} type
 */
Catapult.Buffers.ExchangeOfferBuffer.addType = function (builder, type) {
    builder.addFieldInt8(3, type, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} ownerOffset
 */
Catapult.Buffers.ExchangeOfferBuffer.addOwner = function (builder, ownerOffset) {
    builder.addFieldOffset(4, ownerOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.ExchangeOfferBuffer.createOwnerVector = function (builder, data) {
    builder.startVector(1, data.length, 1);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt8(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.ExchangeOfferBuffer.startOwnerVector = function (builder, numElems) {
    builder.startVector(1, numElems, 1);
};
/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.ExchangeOfferBuffer.endExchangeOfferBuffer = function (builder) {
    var offset = builder.endObject();
    return offset;
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} mosaicIdOffset
 * @param {flatbuffers.Offset} mosaicAmountOffset
 * @param {flatbuffers.Offset} costOffset
 * @param {number} type
 * @param {flatbuffers.Offset} ownerOffset
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.ExchangeOfferBuffer.createExchangeOfferBuffer = function (builder, mosaicIdOffset, mosaicAmountOffset, costOffset, type, ownerOffset) {
    Catapult.Buffers.ExchangeOfferBuffer.startExchangeOfferBuffer(builder);
    Catapult.Buffers.ExchangeOfferBuffer.addMosaicId(builder, mosaicIdOffset);
    Catapult.Buffers.ExchangeOfferBuffer.addMosaicAmount(builder, mosaicAmountOffset);
    Catapult.Buffers.ExchangeOfferBuffer.addCost(builder, costOffset);
    Catapult.Buffers.ExchangeOfferBuffer.addType(builder, type);
    Catapult.Buffers.ExchangeOfferBuffer.addOwner(builder, ownerOffset);
    return Catapult.Buffers.ExchangeOfferBuffer.endExchangeOfferBuffer(builder);
};
/**
 * @constructor
 */
Catapult.Buffers.RemoveExchangeOfferBuffer = function () {
    /**
     * @type {flatbuffers.ByteBuffer}
     */
    this.bb = null;
    /**
     * @type {number}
     */
    this.bb_pos = 0;
};
/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {Catapult.Buffers.RemoveExchangeOfferBuffer}
 */
Catapult.Buffers.RemoveExchangeOfferBuffer.prototype.__init = function (i, bb) {
    this.bb_pos = i;
    this.bb = bb;
    return this;
};
/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {Catapult.Buffers.RemoveExchangeOfferBuffer=} obj
 * @returns {Catapult.Buffers.RemoveExchangeOfferBuffer}
 */
Catapult.Buffers.RemoveExchangeOfferBuffer.getRootAsRemoveExchangeOfferBuffer = function (bb, obj) {
    return (obj || new Catapult.Buffers.RemoveExchangeOfferBuffer).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};
/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.RemoveExchangeOfferBuffer.prototype.mosaicId = function (index) {
    var offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};
/**
 * @returns {number}
 */
Catapult.Buffers.RemoveExchangeOfferBuffer.prototype.mosaicIdLength = function () {
    var offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};
/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.RemoveExchangeOfferBuffer.prototype.mosaicIdArray = function () {
    var offset = this.bb.__offset(this.bb_pos, 4);
    return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};
/**
 * @returns {number}
 */
Catapult.Buffers.RemoveExchangeOfferBuffer.prototype.type = function () {
    var offset = this.bb.__offset(this.bb_pos, 6);
    return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
};
/**
 * @param {flatbuffers.Builder} builder
 */
Catapult.Buffers.RemoveExchangeOfferBuffer.startRemoveExchangeOfferBuffer = function (builder) {
    builder.startObject(2);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} mosaicIdOffset
 */
Catapult.Buffers.RemoveExchangeOfferBuffer.addMosaicId = function (builder, mosaicIdOffset) {
    builder.addFieldOffset(0, mosaicIdOffset, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.RemoveExchangeOfferBuffer.createMosaicIdVector = function (builder, data) {
    builder.startVector(4, data.length, 4);
    for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt32(data[i]);
    }
    return builder.endVector();
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.RemoveExchangeOfferBuffer.startMosaicIdVector = function (builder, numElems) {
    builder.startVector(4, numElems, 4);
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {number} type
 */
Catapult.Buffers.RemoveExchangeOfferBuffer.addType = function (builder, type) {
    builder.addFieldInt8(1, type, 0);
};
/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.RemoveExchangeOfferBuffer.endRemoveExchangeOfferBuffer = function (builder) {
    var offset = builder.endObject();
    return offset;
};
/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} mosaicIdOffset
 * @param {number} type
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.RemoveExchangeOfferBuffer.createRemoveExchangeOfferBuffer = function (builder, mosaicIdOffset, type) {
    Catapult.Buffers.RemoveExchangeOfferBuffer.startRemoveExchangeOfferBuffer(builder);
    Catapult.Buffers.RemoveExchangeOfferBuffer.addMosaicId(builder, mosaicIdOffset);
    Catapult.Buffers.RemoveExchangeOfferBuffer.addType(builder, type);
    return Catapult.Buffers.RemoveExchangeOfferBuffer.endRemoveExchangeOfferBuffer(builder);
};
// Exports for Node.js and RequireJS
exports.default = Catapult;
//# sourceMappingURL=ExchangeOfferTransactionBuffer.js.map